
import { MOCK_LOANS, MOCK_USER, buildLoanProperties } from './shared.mock';

export const userProfileMock = {
  'no-loans': {
    globalUserID: MOCK_USER.globalUserId,
    firstName: MOCK_USER.firstName,
    lastName: MOCK_USER.lastName,
    email: MOCK_USER.email,
    phone: MOCK_USER.phone,
    userProfileID: MOCK_USER.userProfileID,
    createdDate: '2024-01-01T00:00:00Z',
    modifiedDate: null,
    lastLogin: null,
    showContactReview: false,
    properties: [],
  },

  'single-loan': {
    globalUserID: MOCK_USER.globalUserId,
    firstName: MOCK_USER.firstName,
    lastName: MOCK_USER.lastName,
    email: MOCK_USER.email,
    phone: MOCK_USER.phone,
    userProfileID: MOCK_USER.userProfileID,
    createdDate: '2024-01-01T00:00:00Z',
    modifiedDate: null,
    lastLogin: null,
    showContactReview: false,
    properties: [
      ...buildLoanProperties(
        MOCK_LOANS.mortgage.loanNumber,
        MOCK_LOANS.mortgage.encryptionValue,
        MOCK_LOANS.mortgage.collectionId,
        'Mortgage'
      ),
    ],
  },

  'heloc-only': {
    globalUserID: MOCK_USER.globalUserId,
    firstName: MOCK_USER.firstName,
    lastName: MOCK_USER.lastName,
    email: MOCK_USER.email,
    phone: MOCK_USER.phone,
    userProfileID: MOCK_USER.userProfileID,
    createdDate: '2024-01-01T00:00:00Z',
    modifiedDate: null,
    lastLogin: null,
    showContactReview: false,
    properties: [
      ...buildLoanProperties(
        MOCK_LOANS.heloc.loanNumber,
        MOCK_LOANS.heloc.encryptionValue,
        MOCK_LOANS.heloc.collectionId,
        'Heloc'
      ),
    ],
  },

  'multiple-loans': {
    globalUserID: MOCK_USER.globalUserId,
    firstName: MOCK_USER.firstName,
    lastName: MOCK_USER.lastName,
    email: MOCK_USER.email,
    phone: MOCK_USER.phone,
    userProfileID: MOCK_USER.userProfileID,
    createdDate: '2024-01-01T00:00:00Z',
    modifiedDate: null,
    lastLogin: null,
    showContactReview: false,
    properties: [
      ...buildLoanProperties(
        MOCK_LOANS.mortgage.loanNumber,
        MOCK_LOANS.mortgage.encryptionValue,
        MOCK_LOANS.mortgage.collectionId,
        'Mortgage'
      ),
      ...buildLoanProperties(
        MOCK_LOANS.mortgageNoAutopay.loanNumber,
        MOCK_LOANS.mortgageNoAutopay.encryptionValue,
        MOCK_LOANS.mortgageNoAutopay.collectionId,
        'Mortgage'
      ),
      ...buildLoanProperties(
        MOCK_LOANS.heloc.loanNumber,
        MOCK_LOANS.heloc.encryptionValue,
        MOCK_LOANS.heloc.collectionId,
        'Heloc'
      ),
      ...buildLoanProperties(
        MOCK_LOANS.homeEquity.loanNumber,
        MOCK_LOANS.homeEquity.encryptionValue,
        MOCK_LOANS.homeEquity.collectionId,
        'HomeEquity'
      ),
    ],
  },

  'contact-review': {
    globalUserID: MOCK_USER.globalUserId,
    firstName: MOCK_USER.firstName,
    lastName: MOCK_USER.lastName,
    email: MOCK_USER.email,
    phone: MOCK_USER.phone,
    userProfileID: MOCK_USER.userProfileID,
    createdDate: '2024-01-01T00:00:00Z',
    modifiedDate: null,
    lastLogin: null,
    showContactReview: true,
    properties: [
      ...buildLoanProperties(
        MOCK_LOANS.mortgage.loanNumber,
        MOCK_LOANS.mortgage.encryptionValue,
        MOCK_LOANS.mortgage.collectionId,
        'Mortgage'
      ),
    ],
  },
};

export const validateLoanMock = {
  success: {
    isSuccess: true,
    message: 'Loan validated successfully',
    loanNumber: MOCK_LOANS.mortgage.loanNumber,
    phoneNumbers: [
      { key: 'phone1', value: '***-***-5678' },
    ],
    emailIds: [
      { key: 'email1', value: 'j***@example.com' },
    ],
  },
  'invalid-loan': {
    isSuccess: false,
    message: 'Loan number not found or does not match records',
    loanNumber: '',
  },
  'already-registered': {
    isSuccess: false,
    message: 'This loan is already registered to another user',
    loanNumber: '',
  },
};

export const loanLookupMock: Record<string, unknown> = {
  found: {
    found: true,
    message: 'Loan found for this email.',
  },
  'not-found': {
    found: false,
    message: 'No loan found for this email.',
  },
};

export const registerUserMock: Record<string, boolean> = {
  success: true,
};

export const registerLoanMock = {
  success: {
    isSuccess: true,
    message: 'Loan registered successfully',
    encryptionValue: MOCK_LOANS.mortgage.encryptionValue,
  },
  error: {
    isSuccess: false,
    message: 'Failed to register loan. Please try again.',
    encryptionValue: '',
  },
};
